import scssVariables from '@styles/variables.module.scss';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@/components/ui/IconButton';
import { useNavigationStore } from '@/stores/navigation';

export const SidebarToggle = () => {
  const { t } = useTranslation('header');
  const { isCollapsed, toggleCollapse } = useNavigationStore();

  const expandText = t('NavigationButtonShow');
  const collapseText = t('NavigationButtonHide');

  return (
    <IconButton
      size="small"
      color="secondary"
      onClick={toggleCollapse}
      tooltip={isCollapsed ? expandText : collapseText}
      data-automation-id="TopBarSidebarToggle"
      iconName={isCollapsed ? 'dock_to_left' : 'dock_to_right'}
      iconProps={{ color: scssVariables.ColorBlack100 }}
    />
  );
};
